import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45observer_45global from "/app/middleware/route-observer.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  route_45observer_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-only": () => import("/app/middleware/admin-only.ts"),
  "audit-log-permission": () => import("/app/middleware/audit-log-permission.ts"),
  auth: () => import("/app/middleware/auth.ts"),
  "super-admin-only": () => import("/app/middleware/super-admin-only.ts")
}